/* Site-Specific JavaScript */

document.addEventListener('DOMContentLoaded', function () {
    var toggleButtons = document.querySelectorAll('.toggle-btn');

    toggleButtons.forEach(function (button) {
        button.addEventListener('click', function () {
            var targetId = button.getAttribute('data-target');
            var dropdown = targetId ? document.getElementById(targetId) : null;
            if (!dropdown) {
                return;
            }

            var isExpanded = dropdown.classList.toggle('active');
            button.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
            button.querySelector('span').textContent = isExpanded ? '\u2212' : '+';
        });
    });
});
